import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDotsVertical = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 4,
	height: 16,
	viewBox: "0 0 4 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "More options" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.00002 8.83203C2.46026 8.83203 2.83335 8.45894 2.83335 7.9987C2.83335 7.53846 2.46026 7.16536 2.00002 7.16536C1.53978 7.16536 1.16669 7.53846 1.16669 7.9987C1.16669 8.45894 1.53978 8.83203 2.00002 8.83203Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.00002 2.9987C2.46026 2.9987 2.83335 2.6256 2.83335 2.16536C2.83335 1.70513 2.46026 1.33203 2.00002 1.33203C1.53978 1.33203 1.16669 1.70513 1.16669 2.16536C1.16669 2.6256 1.53978 2.9987 2.00002 2.9987Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.00002 14.6654C2.46026 14.6654 2.83335 14.2923 2.83335 13.832C2.83335 13.3718 2.46026 12.9987 2.00002 12.9987C1.53978 12.9987 1.16669 13.3718 1.16669 13.832C1.16669 14.2923 1.53978 14.6654 2.00002 14.6654Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgDotsVertical;
